var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 269.366,
    height: 249.715,
    viewBox: "0 0 269.366 249.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.212,247a99.92,99.92,0,0,0,96.173-72.735c2.422-8.608,39.981-36.988,39.981-46.369C269.366,72.778,188.38,0,133.212,0S-36.9,223.291,11.709,247c29.031,14.162,48.076-31.925,51.947-28.172A99.606,99.606,0,0,0,133.212,247Z",
    transform: "translate(0.304 0.033)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.304 -0.033)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.89,
    cy: 99.802,
    rx: 99.89,
    ry: 99.802,
    transform: "translate(33.626 47.431)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.212,247a99.92,99.92,0,0,0,96.173-72.735c2.422-8.608,39.981-36.988,39.981-46.369C269.366,72.778,188.38,0,133.212,0S-36.9,223.291,11.709,247c29.031,14.162,48.076-31.925,51.947-28.172A99.606,99.606,0,0,0,133.212,247Z",
    transform: "translate(0.304 0.033)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-15.824 14.822)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.505)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,72.134,8.171,34.081C3.615,28.736.53,22.186,1.045,14.847,2.531-6.3,31.993-1.647,37.724,9.025s5.05,37.746-2.356,39.653c-2.954.761-9.247-1.1-15.651-4.96l4.02,28.415Z",
    transform: "translate(0 0)",
    fill: "#b28b67"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 154.15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.846.042C83.949,15.451,91.2,150.623,89.935,152.324c-.841,1.134-89.864,19.27-89.864,19.27l2.566,10.463S106.779,176.93,112.846,169.2c8.686-11.067,21.43-123.821,21.43-123.821Z",
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 56.337, 84.222)",
    fill: "#b28b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.069,167.488l4.52,16.851c51.757,5.966,85.872-1.378,97.876-12.8S123.951,48.054,123.951,48.054L90.329.037C45.344,33.977,72.212,145.155,71.064,147.7S42.622,152.241.069,167.488Z",
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 62.345, 74.031)",
    fill: "#2f3676"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.349 156.179) rotate(20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.474,5.033A2,2,0,0,0,1.908,6.381L0,13.106A64.242,64.242,0,0,0,.9,21H57.3s2.2-7.268-2.538-7.848-7.87-1.047-7.87-1.047L20.68.419a1,1,0,0,0-1.332.532L17.663,5.039s-4.385,2.046-7.127,2.046Z",
    transform: "translate(1 19)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.477,0,50.3,122.754,0,226.532H11.867L141.7,0Z",
    transform: "translate(27.095)",
    fill: "#997659"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.736 196.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.424,4.977A1.978,1.978,0,0,0,1.887,6.31L0,12.954a63.427,63.427,0,0,0,.891,7.8H56.673s2.174-7.182-2.51-7.755-7.783-1.034-7.783-1.034L20.453.418a.989.989,0,0,0-1.317.526L17.469,4.983S13.132,7,10.421,7Z",
    transform: "translate(0.989 18.771)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,204.973l26.369,4.941C46.758,179.965,132.085,57.166,141.44,0h-58.7C51.494,41.325,19.434,174.529,0,204.973Z",
    transform: "translate(31.637 0)",
    fill: "#5c63ab"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.736 50.395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.44,114.889c-1.349-2.266-2.881-4.531-7.538-3.376-8.31,2.062-15.357,7.354-23.106.217-.952-.877-1.65-3.62,1.6-5.026,8.093-3.5,20.049-10.066,21.987-12.614q3.967-5.212,24.583-59.5L69.231,38.6Q38.658,95.528,36.44,98.943c-3.328,5.123-.223,14.513.924,19.458a6.249,6.249,0,0,1-1.411.176C33.514,118.577,32.538,116.733,31.44,114.889ZM193.846,30.254,229.682,14.53A84.916,84.916,0,0,1,247.869.278c1.748-.556,4.735-.724,1.548,3.926s-6.329,9.685-5.056,11.314,4.961-.169,6.419,2.481q1.458,2.651-18.651,6.341L205.289,44.9Z",
    transform: "translate(0 46.443)",
    fill: "#b28b67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.2,8.392,0c20.13,16.361,31.483,58.907,44.349,63.544,12.165,4.384,28.282-2.3,47.365-11.087L107.318,65.4C91.11,86.312,54.405,106,38.131,98.015,12.112,85.257,1.745,32.466,0,2.2Z",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 124.506, 3.072)",
    fill: "#53b6c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,112.648H75.671c3.458,0,2.806-4.989,2.306-7.506C72.208,76.091,49.689,44.774,49.689,3.42L27.862,0C9.809,29.01,3.565,64.728,0,112.648Z",
    transform: "translate(87.033)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,140.177Q15.325,45.214,88.762,0H97.4S126.8,100.1,113.61,133.4H45.494c1.078-16.242,4.533-33.418,9.266-50.165q-23.139,41.7-38.9,60.047Z",
    transform: "translate(24.725)",
    fill: "#83ebf7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.b648225c.svg";
export { ForwardRef as ReactComponent };